/**
 * Mango Voice customer support contact info.
 *
 * Centralized here so the phone number lives in exactly one place. Locale
 * strings should NOT embed the number — compose it in the UI by pairing the
 * translated label with `MANGO_SUPPORT_PHONE.formatted`.
 */
export const MANGO_SUPPORT_PHONE = {
  /** Raw digits, safe for `tel:` URIs */
  digits: '4354662646',
  /** Display-formatted for UI */
  formatted: '(435) 466-2646',
} as const

/**
 * Salesforce Service Cloud Embedded Messaging deployment.
 *
 * These values are not secrets — they're shipped in the page source from the
 * legacy admin app today (see `application/views/layout.php` in legacy-admin).
 * They identify the public Mango_Chat deployment in the Mango Voice Salesforce
 * org. Any origin that loads the bootstrap script must be allowlisted on the
 * Embedded Service deployment in Salesforce.
 */
export const SALESFORCE_CHAT = {
  orgId: '00DHp0000033Fi0',
  deploymentDeveloperName: 'Mango_Chat',
  siteUrl: 'https://mangovoice.my.site.com/ESWMangoChat1708977507052',
  scrt2Url: 'https://mangovoice.my.salesforce-scrt.com',
  language: 'en_US',
  bootstrapScript:
    'https://mangovoice.my.site.com/ESWMangoChat1708977507052/assets/js/bootstrap.min.js',
} as const
